import { jt } from "ttag";

import { Text } from "metabase/ui";
import type { ColorName } from "metabase/ui/colors/types";
import { isEmpty } from "metabase/utils/validate";

import type { ComparisonResult } from "../compute";

interface Props {
  color: ColorName;
  comparison: ComparisonResult;
  valueFormatted: string | number | JSX.Element | null;
}

export function DetailCandidate({ color, comparison, valueFormatted }: Props) {
  const { comparisonDescStr } = comparison;

  if (isEmpty(valueFormatted)) {
    return comparisonDescStr;
  }

  // IBM text_contrast_sufficient targets this span (fw inherits 700 from the
  // Title). Set both `color` (--text-color / Text.css) and `c` so the painted
  // channel is the opaque token, not an inherited tertiary/disabled alpha.
  if (isEmpty(comparisonDescStr)) {
    return (
      <Text c={color} color={color} component="span" lh={1}>
        {valueFormatted}
      </Text>
    );
  }

  return jt`${comparisonDescStr}: ${(
    <Text key="value-str" c={color} color={color} component="span" lh={1}>
      {valueFormatted}
    </Text>
  )}`;
}
